<template>
  <div>
    <el-card class="box-card">
      <!-- 说明 -->
      <el-alert title="此页面为运营商配置卡券价格/押金/骑行险金额。先在「卡类型配置」创建卡券模板,再在此页为各运营商开启并设置价格" type="info" :closable="false" style="margin-bottom: 15px;"></el-alert>

      <!-- 运营商选择 -->
      <div style="margin-bottom: 20px;">
        <el-form :inline="true" size="small" label-width="80px">
          <el-form-item label="运营商:">
            <el-select v-model="distributorId" clearable filterable placeholder="请选择运营商" style="width: 240px;">
              <el-option v-for="item in distributorOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="getList">查询</el-button>
            <el-button type="success" :disabled="!distributorId" @click="openAddDialog">+ 为运营商开启卡券</el-button>
          </el-form-item>
        </el-form>
      </div>

      <!-- 表格 -->
      <el-table :data="cardList" border stripe :header-cell-style="{ textAlign: 'center' }" :cell-style="{ textAlign: 'center' }" v-loading="loading">
        <el-table-column type="index" label="序号" width="60"></el-table-column>
        <el-table-column label="运营商" width="140">
          <template slot-scope="scope">{{ scope.row.distributorName || scope.row.distributorId }}</template>
        </el-table-column>
        <el-table-column label="卡名称" prop="cardName"></el-table-column>
        <el-table-column label="车辆类型" width="110">
          <template slot-scope="scope">{{ scope.row.deviceTypeName || deviceTypeText(scope.row.deviceTypeCode) }}</template>
        </el-table-column>
        <el-table-column label="卡类型">
          <template slot-scope="scope">
            <el-tag :type="cardTypeTag(scope.row.cardType)">{{ cardTypeText(scope.row.cardType) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="有效小时数" width="110">
          <template slot-scope="scope">{{ scope.row.validHours != null ? scope.row.validHours : (scope.row.validDays != null ? scope.row.validDays + '天' : '-') }}</template>
        </el-table-column>
        <el-table-column label="价格(元)" prop="price" width="100"></el-table-column>
        <el-table-column label="押金(元)" prop="depositAmount" width="100"></el-table-column>
        <el-table-column label="骑行险金额(元)" width="120">
          <template slot-scope="scope">
            {{ scope.row.insuranceEnabled == 1 ? '¥' + scope.row.insuranceAmount : '-' }}
          </template>
        </el-table-column>
        <el-table-column label="状态" width="80">
          <template slot-scope="scope">
            <el-tag :type="scope.row.enabled == 1 ? 'success' : 'danger'" size="small">
              {{ scope.row.enabled == 1 ? '开启' : '关闭' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="360">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" icon="el-icon-edit" @click="openEditDialog(scope.row)">编辑价格</el-button>
            <el-button size="mini" :type="scope.row.enabled == 1 ? 'warning' : 'success'"
                       @click="toggleEnabled(scope.row)">
              {{ scope.row.enabled == 1 ? '关闭' : '开启' }}
            </el-button>
            <el-button v-if="isSuperAuthority" size="mini" type="danger" icon="el-icon-delete" @click="deleteCard(scope.row.id)">移除</el-button>
            <el-button v-if="scope.row.insuranceEnabled == 1 && isSuperAuthority" size="mini" type="warning" @click="openInsuranceSplitDialog(scope.row)">分账配置</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- 新增/编辑弹窗 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="620px" @close="resetForm">
      <el-form :model="formData" :rules="formRules" ref="cardForm" label-width="130px" size="small">
        <el-form-item label="运营商">
          <el-input :value="currentDistributorName" disabled></el-input>
        </el-form-item>
        <el-form-item label="选择卡券模板" prop="passCardId" v-if="!isEdit">
          <el-select v-model="formData.passCardId" placeholder="请选择卡券模板" style="width: 100%;" @change="onTemplateChange">
            <el-option v-for="item in availableTemplates" :key="item.id"
                       :label="item.cardName + ' (' + cardTypeText(item.cardType) + ', ' + (item.validHours != null ? item.validHours + '小时' : (item.validDays != null ? item.validDays + '天' : '')) + ')' + (item.attachedTypes.length > 0 ? ' [已配:' + item.attachedTypes.join('/') + ']' : '')"
                       :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="卡券模板" v-else>
          <el-input :value="formData.cardName + ' (' + cardTypeText(formData.cardType) + ')'" disabled></el-input>
        </el-form-item>
        <el-form-item label="车辆类型">
          <el-input :value="formData.deviceTypeName || deviceTypeText(formData.deviceTypeCode)" disabled placeholder="选择卡券模板后自动带出" style="width: 100%;"></el-input>
          <div style="color:#909399;font-size:12px;">车辆类型由所选卡券模板决定,无需手动选择</div>
        </el-form-item>
        <el-form-item label="卡价格(元)" prop="price">
          <el-input-number v-model="formData.price" :precision="2" :min="0" :step="0.5" style="width: 100%;"></el-input-number>
        </el-form-item>
        <el-form-item label="押金金额(元)" prop="depositAmount">
          <el-input-number v-model="formData.depositAmount" :precision="2" :min="0" :step="1" style="width: 100%;"></el-input-number>
        </el-form-item>
        <el-form-item label="骑行险金额(元)" prop="insuranceAmount" v-if="formData.insuranceEnabled == 1">
          <el-input-number v-model="formData.insuranceAmount" :precision="2" :min="0" :step="0.1" style="width: 100%;"></el-input-number>
          <div style="color:#909399;font-size:12px;">此卡券模板包含骑行险,骑行险金额从押金中扣除分给保险公司</div>
        </el-form-item>
        <el-form-item label="开启状态">
          <el-switch v-model="formData.enabled" :active-value="1" :inactive-value="0"></el-switch>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button v-if="isSuperAuthority" type="primary" @click="submitForm">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 骑行险分账配置弹窗 -->
    <el-dialog :title="'卡券骑行险分账配置 - ' + insuranceSplitDistributorName" :visible.sync="insuranceSplitDialogVisible" width="1000px" append-to-body>
      <div style="margin-bottom: 15px; display: flex; align-items: center;">
        <span style="margin-right: 10px;">保险产品：</span>
        <el-select v-model="insuranceSplitProductNo" size="small" disabled style="width: 200px;">
          <el-option label="单次骑行险 (P001)" value="P001"></el-option>
          <el-option label="包日骑行险 (P002)" value="P002"></el-option>
          <el-option label="包周骑行险 (P003)" value="P003"></el-option>
          <el-option label="包月骑行险 (P004)" value="P004"></el-option>
        </el-select>
        <span style="margin-left: 20px; margin-right: 10px;">车辆类型：</span>
        <el-select v-model="insuranceSplitDeviceTypeCode" size="small" disabled style="width: 220px;" placeholder="由卡券决定">
          <el-option v-for="item in deviceTypeOptions" :key="item.deviceTypeCode"
                     :label="item.deviceTypeName" :value="item.deviceTypeCode"></el-option>
        </el-select>
      </div>
      <el-alert title="保险金额必须按支付渠道分别配齐，每个渠道的启用明细合计需等于骑行险金额。支付渠道选择'全部'时该明细对所有渠道生效。" type="warning" :closable="false" style="margin-bottom: 15px;"></el-alert>
      <div style="margin-bottom: 10px; display: flex; justify-content: space-between; align-items: center;">
        <div>
          <span>骑行险金额：{{ insuranceSplitCurrentAmount }} 元</span>
          <span style="margin-left: 20px;" :style="{ color: insuranceSplitRemain === 0 ? '#67C23A' : '#F56C6C' }">{{ insuranceSplitChannelStatus }}</span>
        </div>
        <el-button v-if="isSuperAuthority" size="small" type="primary" icon="el-icon-plus" @click="addInsuranceSplitDetail">添加接收方</el-button>
      </div>
      <el-table :data="insuranceSplitForm.details" border stripe>
        <el-table-column label="接收方类型" width="130">
          <template slot-scope="scope">
            <el-select v-model="scope.row.receiverType" size="small" placeholder="请选择">
              <el-option label="保险公司" :value="1"></el-option>
              <el-option label="商户" :value="2"></el-option>
              <el-option label="平台" :value="3"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="支付渠道" width="120">
          <template slot-scope="scope">
            <el-select v-model="scope.row.payChannel" size="small" placeholder="请选择">
              <el-option label="全部" :value="null"></el-option>
              <el-option label="微信" :value="1"></el-option>
              <el-option label="银联" :value="2"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="接收方账号">
          <template slot-scope="scope">
            <el-input v-model.trim="scope.row.receiverAccount" size="small" placeholder="商户号/openid"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="接收方名称">
          <template slot-scope="scope">
            <el-input v-model.trim="scope.row.receiverName" size="small" placeholder="名称"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="固定金额" width="120">
          <template slot-scope="scope">
            <el-input v-model="scope.row.splitAmount" size="small" placeholder="如：1.00"></el-input>
          </template>
        </el-table-column>
        <el-table-column v-if="isSuperAuthority" label="启用" width="70">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.enabled"></el-switch>
          </template>
        </el-table-column>
        <el-table-column v-if="isSuperAuthority" label="操作" width="80">
          <template slot-scope="scope">
            <el-button v-if="isSuperAuthority" size="mini" type="danger" @click="removeInsuranceSplitDetail(scope.$index)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="insuranceSplitDialogVisible = false">取 消</el-button>
        <el-button v-if="isSuperAuthority" type="primary" @click="saveInsuranceSplitConfig">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      distributorId: '',
      distributorOptions: [],
      cardList: [],
      loading: false,
      allTemplates: [],
      dialogVisible: false,
      isEdit: false,
      formData: {
        id: null, distributorId: '', passCardId: '', deviceTypeCode: 'ALL', deviceTypeName: '',
        price: 0, depositAmount: 0, insuranceAmount: 0, enabled: 1,
        // 以下为模板回显字段(非提交)
        cardName: '', cardType: null, insuranceEnabled: 1, validHours: null, validDays: null
      },
      formRules: {
        passCardId: [{ required: true, message: '请选择卡券模板', trigger: 'change' }],
        price: [{ required: true, message: '请输入卡价格', trigger: 'blur' }]
      },
      // 骑行险分账配置
      insuranceSplitDialogVisible: false,
      insuranceSplitDistributorId: '',
      insuranceSplitDistributorName: '',
      insuranceSplitProductNo: '',
      insuranceSplitDeviceTypeCode: '',
      deviceTypeOptions: [],
      insuranceSplitForm: { details: [], insuranceAmount: 0 },
      isSuperAuthority: false
    }
  },
  computed: {
    dialogTitle() { return this.isEdit ? '编辑运营商卡券价格' : '为运营商开启卡券'; },
    currentDistributorName() {
      // 优先用当前编辑行的运营商,回退到顶部筛选的运营商
      const targetId = this.formData.distributorId || this.distributorId;
      const d = this.distributorOptions.find(i => i.id === targetId);
      return d ? d.name : '';
    },
    // 可添加的模板:同模板可为不同车辆类型分别配置,label标注已配置的类型
    availableTemplates() {
      return this.allTemplates.map(t => {
        // 优先用卡券记录里的 deviceTypeName(后端已回填),回退到 deviceTypeText 查 deviceTypeOptions
        const attached = this.cardList.filter(c => c.passCardId === t.id).map(c => c.deviceTypeName || this.deviceTypeText(c.deviceTypeCode));
        return { ...t, attachedTypes: attached };
      });
    },
    // 当前编辑的骑行险金额
    insuranceSplitCurrentAmount() {
      return this.insuranceSplitForm.insuranceAmount || 0;
    },
    // 按支付渠道分组计算分账金额合计 { 0:全部, 1:微信, 2:银联 }
    insuranceSplitChannelTotals() {
      const totals = { 0: 0, 1: 0, 2: 0 };
      (this.insuranceSplitForm.details || []).forEach(item => {
        if (!item.enabled) return;
        const amount = parseFloat(item.splitAmount) || 0;
        const key = item.payChannel == null ? 0 : item.payChannel;
        totals[key] = Math.round((totals[key] + amount) * 100) / 100;
      });
      return totals;
    },
    // 校验所有已配置渠道是否都已配齐
    insuranceSplitRemain() {
      const amount = this.insuranceSplitCurrentAmount;
      const totals = this.insuranceSplitChannelTotals;
      const configuredChannels = [];
      if (totals[0] > 0) configuredChannels.push(0);
      if (totals[1] > 0) configuredChannels.push(1);
      if (totals[2] > 0) configuredChannels.push(2);
      if (configuredChannels.length === 0) return amount;
      let maxDiff = 0;
      for (const ch of configuredChannels) {
        const diff = Math.round((amount - totals[ch]) * 100) / 100;
        if (Math.abs(diff) > Math.abs(maxDiff)) maxDiff = diff;
      }
      return maxDiff;
    },
    // 分渠道显示状态文本
    insuranceSplitChannelStatus() {
      const amount = this.insuranceSplitCurrentAmount;
      const totals = this.insuranceSplitChannelTotals;
      const parts = [];
      const names = { 0: '全部', 1: '微信', 2: '银联' };
      for (const ch of [0, 1, 2]) {
        if (totals[ch] > 0) {
          const ok = Math.abs(amount - totals[ch]) < 0.01;
          parts.push(`${names[ch]}: ${this.formatMoney(totals[ch])}元 ${ok ? '✓' : '✗'}`);
        }
      }
      return parts.length > 0 ? parts.join('  |  ') : '未配置';
    }
  },
  created() {
    this.initCurrentRoleCode();
    this.getDistributorOptions();
    this.getAllTemplates();
    this.getList();
  },
  methods: {
    initCurrentRoleCode() {
      const roleCodes = JSON.parse(window.sessionStorage.getItem('roleCodes') || '[]');
      const roles = JSON.parse(window.sessionStorage.getItem('roles') || '[]');
      this.isSuperAuthority = roleCodes.includes('SUPER_AUTHORITY') || roles.some(role => role.roleCode === 'SUPER_AUTHORITY');
    },
    // 打开卡券骑行险分账配置弹窗(直接用该行卡券所属运营商和车辆类型,无需手动选)
    async openInsuranceSplitDialog(row) {
      if (!row.insuranceAmount || parseFloat(row.insuranceAmount) <= 0) {
        return this.$message.warning('请先在「编辑价格」中填写该卡券的骑行险金额');
      }
      this.insuranceSplitDistributorId = row.distributorId;
      const distributor = this.distributorOptions.find(i => i.id === row.distributorId);
      this.insuranceSplitDistributorName = distributor ? distributor.name : (row.distributorName || row.distributorId);
      this.insuranceSplitProductNo = row.insuranceProductNo || 'P002';
      this.insuranceSplitForm.insuranceAmount = parseFloat(row.insuranceAmount) || 0;
      this.insuranceSplitForm.details = [];
      // 车辆类型由卡券行决定,不可手动选择
      this.insuranceSplitDeviceTypeCode = row.deviceTypeCode;
      // 加载该运营商的车辆类型列表(用于回显名称)
      await this.loadDeviceTypes(this.insuranceSplitDistributorId);
      this.insuranceSplitDialogVisible = true;
      this.loadInsuranceSplitConfig();
    },
    async loadInsuranceSplitConfig() {
      if (!this.insuranceSplitDistributorId || !this.insuranceSplitDeviceTypeCode) return;
      try {
        const { data: res } = await this.$http.get('/insurance/split/config/get', {
          params: {
            distributorId: this.insuranceSplitDistributorId,
            deviceTypeCode: this.insuranceSplitDeviceTypeCode,
            productNo: this.insuranceSplitProductNo
          }
        });
        if (res.code !== 200) return this.$message.error(res.msg);
        const details = res.data && res.data.details ? res.data.details : [];
        this.insuranceSplitForm.details = details.map(item => ({
          id: item.id,
          receiverType: item.receiverType,
          payChannel: item.payChannel,
          receiverAccount: item.receiverAccount,
          receiverName: item.receiverName,
          splitAmount: item.splitAmount,
          priority: item.priority,
          enabled: item.enabled === 1,
          remark: item.remark
        }));
        // 骑行险金额以卡券配置为准,不被分账配置覆盖
      } catch (error) {
        this.$message.error('加载保险分账配置失败');
      }
    },
    addInsuranceSplitDetail() {
      this.insuranceSplitForm.details.push({
        receiverType: 2,
        payChannel: null,
        receiverAccount: '',
        receiverName: '',
        splitAmount: null,
        priority: this.insuranceSplitForm.details.length + 1,
        enabled: true,
        remark: ''
      });
    },
    removeInsuranceSplitDetail(index) {
      this.insuranceSplitForm.details.splice(index, 1);
    },
    async saveInsuranceSplitConfig() {
      if (!this.insuranceSplitDeviceTypeCode) {
        return this.$message.error('请选择设备类型');
      }
      if (Math.abs(this.insuranceSplitRemain) > 0.009) {
        return this.$message.error('每个已配置的支付渠道分账金额合计必须等于骑行险金额');
      }
      for (const item of this.insuranceSplitForm.details) {
        if (!item.enabled) continue;
        if (!item.receiverType || !item.receiverAccount || !item.receiverName || !item.splitAmount || parseFloat(item.splitAmount) <= 0) {
          return this.$message.error('请完整填写启用的保险分账明细');
        }
      }
      const deviceType = this.deviceTypeOptions.find(d => d.deviceTypeCode === this.insuranceSplitDeviceTypeCode) || {};
      const distributor = this.distributorOptions.find(i => i.id === this.insuranceSplitDistributorId);
      const payload = {
        distributorId: this.insuranceSplitDistributorId,
        distributorName: distributor ? distributor.name : '',
        deviceTypeCode: this.insuranceSplitDeviceTypeCode,
        deviceTypeName: deviceType.deviceTypeName || '',
        bicycleType: deviceType.bicycleType,
        insuranceAmount: this.insuranceSplitCurrentAmount,
        productNo: this.insuranceSplitProductNo,
        enabled: 1,
        details: this.insuranceSplitForm.details.map((item, index) => ({
          receiverType: item.receiverType,
          payChannel: item.payChannel,
          receiverAccount: item.receiverAccount,
          receiverName: item.receiverName,
          splitAmount: item.splitAmount,
          priority: index + 1,
          enabled: item.enabled ? 1 : 0,
          remark: item.remark
        }))
      };
      const { data: res } = await this.$http.post('/insurance/split/config/save', payload);
      if (res.code !== 200) return this.$message.error(res.msg);
      this.$message.success('保存成功');
      this.insuranceSplitDialogVisible = false;
    },
    formatMoney(value) {
      const num = parseFloat(value) || 0;
      return num.toFixed(2);
    },
    async getDistributorOptions() {
      const { data: res } = await this.$http.get('/distributor/manager/getAllDistributorInfo');
      if (res.code == 200) {
        this.distributorOptions = res.data;
      }
    },
    async getAllTemplates() {
      // distributorId 为空时查全部模板(后端已支持),保证查询全部模式下也能选模板新增
      const params = this.distributorId ? { distributorId: this.distributorId } : {};
      const { data: res } = await this.$http.get('/passCard/distributorCard/allTemplates', { params });
      if (res.code == 200) {
        this.allTemplates = res.data || [];
      }
    },
    async getList() {
      this.loading = true;
      try {
        const params = this.distributorId ? { distributorId: this.distributorId } : {};
        const { data: res } = await this.$http.get('/passCard/distributorCard/list', { params });
        if (res.code == 200) {
          this.cardList = res.data || [];
        } else {
          this.$message.error(res.msg);
        }
      } finally {
        this.loading = false;
      }
    },
    onDistributorChange() {
      this.getList();
      this.getAllTemplates();
      this.loadDeviceTypes();
    },
    // 加载运营商的车辆类型列表(不传时用顶部选中的运营商)
    async loadDeviceTypes(distributorId) {
      const targetId = distributorId || this.distributorId;
      if (!targetId) {
        this.deviceTypeOptions = [];
        return;
      }
      try {
        const { data: res } = await this.$http.get('/device/typeConfig/list', { params: { distributorId: targetId, bicycleType: null } });
        if (res.code == 200) {
          this.deviceTypeOptions = res.data || [];
        }
      } catch (e) {
        console.error('加载车辆类型失败', e);
      }
    },
    cardTypeText(type) { return { 1: '日卡', 2: '周卡', 3: '月卡', 4: '自定义' }[type] || '-'; },
    cardTypeTag(type) { return { 1: '', 2: 'success', 3: 'warning', 4: 'info' }[type] || ''; },
    deviceTypeText(code) {
      if (!code || code === 'ALL') return '不限';
      const d = this.deviceTypeOptions.find(i => i.deviceTypeCode === code);
      return d ? d.deviceTypeName : code;
    },
    onTemplateChange(passCardId) {
      // 选择模板时回显模板信息(含车辆类型,由模板决定)
      const tpl = this.allTemplates.find(t => t.id === passCardId);
      if (tpl) {
        this.formData.cardName = tpl.cardName;
        this.formData.cardType = tpl.cardType;
        this.formData.insuranceEnabled = tpl.insuranceEnabled;
        this.formData.validHours = tpl.validHours;
        this.formData.validDays = tpl.validDays;
        this.formData.deviceTypeCode = tpl.deviceTypeCode || '';
        // allTemplates 接口不回填 deviceTypeName,从 cardList 里找同模板已配置的记录补名称
        const sameTplCard = this.cardList.find(c => c.passCardId === tpl.id);
        this.formData.deviceTypeName = (sameTplCard && sameTplCard.deviceTypeName) || tpl.deviceTypeName || '';
        this.formData.bicycleType = tpl.bicycleType;
        // 骑行险金额默认用模板值(若模板有)
        if (tpl.insuranceEnabled == 1 && tpl.insuranceAmount != null) {
          this.formData.insuranceAmount = tpl.insuranceAmount;
        }
        if (tpl.depositAmount != null) {
          this.formData.depositAmount = tpl.depositAmount;
        }
      }
    },
    openAddDialog() {
      this.isEdit = false;
      this.resetForm();
      this.formData.distributorId = this.distributorId;
      this.dialogVisible = true;
    },
    openEditDialog(row) {
      this.isEdit = true;
      this.formData = JSON.parse(JSON.stringify(row));
      this.dialogVisible = true;
    },
    resetForm() {
      this.formData = {
        id: null, distributorId: this.distributorId, passCardId: '', deviceTypeCode: 'ALL', deviceTypeName: '',
        price: 0, depositAmount: 0, insuranceAmount: 0, enabled: 1,
        cardName: '', cardType: null, insuranceEnabled: 1, validHours: null, validDays: null
      };
      if (this.$refs.cardForm) this.$refs.cardForm.clearValidate();
    },
    submitForm() {
      this.$refs.cardForm.validate((valid) => {
        if (!valid) return;
        const payload = {
          id: this.formData.id,
          distributorId: this.distributorId || this.formData.distributorId,
          passCardId: this.formData.passCardId,
          deviceTypeCode: this.formData.deviceTypeCode,
          price: this.formData.price,
          depositAmount: this.formData.depositAmount,
          insuranceAmount: this.formData.insuranceEnabled == 1 ? this.formData.insuranceAmount : 0,
          enabled: this.formData.enabled
        };
        this.$http.post('/passCard/distributorCard/save', payload).then((res) => {
          if (res.data.code != 200) return this.$message.error(res.data.msg);
          this.dialogVisible = false;
          this.getList();
          this.$message.success(res.data.msg);
        });
      });
    },
    toggleEnabled(row) {
      const action = row.enabled == 1 ? '关闭' : '开启';
      this.$confirm(`确定${action}「${row.cardName}」吗？`, '提示', { type: 'warning' }).then(() => {
        this.$http.post('/passCard/distributorCard/toggleEnabled', null, {
          params: { id: row.id, enabled: row.enabled == 1 ? 0 : 1 }
        }).then((res) => {
          if (res.data.code != 200) return this.$message.error(res.data.msg);
          this.$message.success(res.data.msg);
          this.getList();
        });
      }).catch(() => {});
    },
    deleteCard(id) {
      this.$confirm('确定移除此卡券配置吗？移除后该运营商将不再展示此卡券。', '警告', { type: 'warning' }).then(() => {
        this.$http.post('/passCard/distributorCard/delete', null, { params: { id } }).then((res) => {
          if (res.data.code != 200) return this.$message.error(res.data.msg);
          this.$message.success(res.data.msg);
          this.getList();
        });
      }).catch(() => {});
    }
  }
}
</script>
